import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { StateService, StateParams } from '@uirouter/core';
import { EnumService } from '../../../app.common/modules/common/services/enum.service';
import { UrlService } from '../../../app.common/modules/common/services/url.service';
import { SettingsService } from '../../../app.common/modules/common/services/settings.service';
import { AccountService } from '../account/account.service';
import { IRetailerRootScope } from './models';


function appRun(
    $rootScope: IRetailerRootScope,
    $state: StateService,
    $stateParams: StateParams,
    $localStorage: ngStorage.StorageService,
    settingsService: SettingsService,
    accountService: AccountService,
    enumService: EnumService,
    urlService: UrlService
) {

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.$storage = $localStorage;
    settingsService.init();
    accountService.fillAuthData();
    $rootScope.getContentHtmlUrl = urlService.getRetailersHtmlUrl;
    $rootScope.currentYear = new Date().getFullYear();
    $rootScope.enums = enumService;
}

angular.module('naut').run(appRun);

appRun.$inject = ['$rootScope', '$state', '$stateParams', '$localStorage', 'settingsService', 'accountService', 'enumService', 'urlService'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/core/core.run.ts